const isOffline = ({ status }) => status === 'disconnected';

const sortRoutesAscending = property => (a, b) => {
  const aIsOffline = isOffline(a);
  const bIsOffline = isOffline(b);

  if (aIsOffline) return -1; // sort a after b
  if (bIsOffline) return 1; // sort a before b

  return a[property] >= b[property] ? 1 : -1;
};

export default function sortRoutes(routes, value, order) {
  const result = [...routes];

  switch (value) {
    case 'tti':
      result.sort(sortRoutesAscending('travelTimeIndex'));
      break;
    case 'speed':
      result.sort(sortRoutesAscending('liveSpeed'));
      break;
    default:
  }

  return order === 'asc' ? result : result.reverse();
}



// WEBPACK FOOTER //
// ./src/helpers/sortRoutes.js